export enum PeriodCycle {
	MONTHLY = 'monthly_1',
	YEARLY = 'yearly',
}

export interface UpdateSubscriptionItemDTO {
	id: number
	quantity: number
}

export interface UpdateSubscriptionRequestDTO {
	plan_id: number
	period_cycle: PeriodCycle
	items: UpdateSubscriptionItemDTO[]
	/** Optional: Player IDs to remove when deleting a zone + lowering subscription by 1 license */
	players?: number[]
	/** The password of the account owner (required for downgrades/deletions) */
	password?: string
}
